import React from 'react';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import RubriqSelectedCriteria from './RubriqSelectedCriteria';
var RubriqSelectedCriteriaModal = function RubriqSelectedCriteriaModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  // TODO get stage from the state / api when we have the concept of a stage
  var currentStage = window.location.href.includes('/criteria') ? 'setup' : 'template';
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var criteriaResponses = curie.abstractWriter.criteriaResponses;
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: window.document.querySelector('#researcher-app'),
    className: "react-modal",
    isOpen: true,
    overlayClassName: "react-modal-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: onClose,
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "setup criteria"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: '60vh'
    },
    className: "react-modal-content overflow-y-scroll"
  }, Object.keys(criteriaResponses).length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, currentStage === 'setup' ? /*#__PURE__*/React.createElement(T, {
    source: "curie.selected-criteria-message-during-setup"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "curie.selected-criteria-message-post-setup"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RubriqSelectedCriteria, {
    showClickableLinks: false
  }))) : /*#__PURE__*/React.createElement(T, {
    source: "curie.no-criteria-selected"
  })), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer border-top bg-white"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('close'),
    type: "button",
    className: "btn btn-primary btn-squared",
    onClick: function onClick() {
      return onClose();
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "close"
  })))));
};
export default RubriqSelectedCriteriaModal;